// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"764":"4b183b25","791":"f406f7ee","859":"5e6e1853","940":"7601ae6a"}[chunkId] + ".css";
};